import React from "react";


import { RegistorClass } from "../core/ComponentRegistor";
import { Menu, Icon, Switch } from 'antd';

const { SubMenu } = Menu;

export class AntMemu extends React.Component<any>  {
    state = {
        theme: 'light',
        current: '1',
    };

    changeTheme = value => {
        this.setState({
            theme: value ? 'dark' : 'light',
        });
    };

    handleClick = e => {
        console.log('click ', e);
        this.setState({
            current: e.key,
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Switch
                    checked={this.state.theme === 'dark'}
                    onChange={this.changeTheme}
                    checkedChildren="Dark"
                    unCheckedChildren="Light"
                />
                <br />
                <br />
                <Menu
                    // theme={this.state.theme}
                    onClick={this.handleClick}
                    style={{ width: 256 }}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[this.state.current]}
                    mode="inline"
                    theme={(this.state.theme == 'dark') ? 'dark' : 'light'}
                >
                    <SubMenu
                        key="sub1"
                        title={
                            <span>
                                <Icon type="mail" />
                                <span>Navigation One</span>
                            </span>
                        }
                    >

                        <Menu.Item key="1" onClick={() => { this.props.itemClick('1') }}>Option 1</Menu.Item>,
                        <Menu.Item key="2" onClick={() => { this.props.itemClick('2') }}>Option 2</Menu.Item>
                        <Menu.Item key="3" onClick={() => { this.props.itemClick('3') }}>Option 3</Menu.Item>
                        <Menu.Item key="4" onClick={() => { this.props.itemClick('4') }}>Option 4</Menu.Item>
                    </SubMenu>
                    <SubMenu
                        key="sub2"
                        title={
                            <span>
                                <Icon type="appstore" />
                                <span>Navigation Two</span>
                            </span>
                        }
                    >
                        <Menu.Item key="5" onClick={() => { this.props.itemClick('5') }}>Option 5</Menu.Item>
                        <Menu.Item key="6">onClick={() => { this.props.itemClick('6') }}Option 6</Menu.Item>
                        <SubMenu key="sub3" title="Submenu">
                            <Menu.Item key="7" onClick={() => { this.props.itemClick('7') }}>Option 7</Menu.Item>
                            <Menu.Item key="8" onClick={() => { this.props.itemClick('8') }}>Option 8</Menu.Item>
                        </SubMenu>
                    </SubMenu>
                    <SubMenu
                        key="sub4"
                        title={
                            <span>
                                <Icon type="setting" />
                                <span>Navigation Three</span>
                            </span>
                        }
                    >
                        <Menu.Item key="9">Option 9</Menu.Item>
                        <Menu.Item key="10">Option 10</Menu.Item>
                        <Menu.Item key="11">Option 11</Menu.Item>
                        <Menu.Item key="12">Option 12</Menu.Item>
                    </SubMenu>
                </Menu>
            </div>
        );
    }
}


let scheme = {
    "type": "object",
    "properties": {
        "span": {
            "type": "number",
            "label": "占位",
        },
        "label": {
            "type": "string",
            "label": "显示名",
        }
    }
}
// RegistorClass({
//     componentTag: "AntMemu",
//     componentObject: AntMemu,
//     componentName: "Ant导航栏",
//     scheme: scheme,
//     defaultProps: {
//         span: 24,
//         lable: "导航栏",
//         required: false
//     }
// })
// export default AntTextarea